
import ItemNotFound from '@/components/common/ItemNotFound.vue'
import PageHeader from '@/components/common/PageHeader.vue'
import MoList from '@/components/mo/MoList.vue'
import DataTableMixin from '@/components/mixins/DataTableMixin.vue'
import { EXPORT_MANUFACTURING_ORDER, FETCH_MANUFACTURING_ORDERS, SET_HAVE_NEW_EXPORT_RECORD } from '@/store/actions'
import { FILTER_DEBOUNCE_TIME } from '@/utils/constants'
import errorHandler from '@/utils/errorHandler'
import { IManufacturingPlan } from '@/utils/types/model/manufacturingPlan'
import debounce from 'lodash/debounce'
import { Options } from 'vue-class-component'
import { Mixins, Watch } from 'vue-property-decorator'
import { EExportType } from '@/utils/enums'

interface ICommonSearch {
  orderNumber?: string
  sortBy?: string
  sortType?: string
  [key: string]: string | undefined
}

@Options({
  components: { PageHeader, ItemNotFound, MoList },
  name: 'ManufacturingPlan',
})
export default class ManufacturingPlan extends Mixins(DataTableMixin) {
  dataSearch: ICommonSearch = {}
  debounceFilter!: () => void

  get isMOLoading(): boolean {
    return this.$store.getters.isMOLoading || false
  }

  get getTotalRecords(): number {
    return this.$store.getters.getTotalRecords || 0
  }

  get getMOItems(): IManufacturingPlan[] {
    return this.$store.getters.getMOItems || []
  }

  refreshItemList() {
    this.debounceFilter()
  }

  handleDetail(orderId: number | string) {
    this.$router.push({ name: 'mo-detail', params: { id: orderId.toString() } })
  }

  handleSortChange(data: { prop: string; order: string | null }) {
    this.dataSearch.sortBy = data.prop
    this.dataSearch.sortType = data.order ? (data.order === 'ascending' ? 'asc' : 'desc') : undefined
    this.currentPageNum = 1
    this.redirectIndex()
    this.fetchList()
  }

  async exportCSV() {
    try {
      await this.$store.dispatch(EXPORT_MANUFACTURING_ORDER, {
        sortBy: this.dataSearch.sortBy,
        sortType: this.dataSearch.sortType,
      })
      this.$store.commit(SET_HAVE_NEW_EXPORT_RECORD, { exportType: EExportType.MASTER_DATA, isHaveNew: true })
    } catch (e) {
      errorHandler(e)
    }
  }

  fetchList() {
    try {
      this.$store.dispatch(FETCH_MANUFACTURING_ORDERS, {
        page: this.currentPageNum,
        limit: this.itemsPerPage,
        orderNumber: this.dataSearch.orderNumber || '',
        sortBy: this.dataSearch.sortBy,
        sortType: this.dataSearch.sortType,
      })
    } catch (e) {
      errorHandler(e, {}, true)
    }
  }

  created() {
    this.routeName = 'manufacturing-plan'
    this.getQueryData()
    this.debounceFilter = debounce(() => {
      this.currentPageNum = 1
      this.redirectIndex()
      this.fetchList()
    }, FILTER_DEBOUNCE_TIME)
    this.fetchList()
  }

  currentPageChange(pageNum: number) {
    this.currentPageNum = pageNum
    this.redirectIndex()
    this.fetchList()
  }
}
